<header>
  <div class="logo">
    <img src="assets/img/accesshublogo.png" alt="accesshublogo">
  </div>
</header>

<div class="login-bg">
  <router-outlet></router-outlet>
</div>
